import { render, staticRenderFns } from "./DelBusinessDatabus.vue?vue&type=template&id=0888a108&scoped=true"
import script from "./DelBusinessDatabus.vue?vue&type=script&lang=js"
export * from "./DelBusinessDatabus.vue?vue&type=script&lang=js"
import style0 from "./DelBusinessDatabus.vue?vue&type=style&index=0&id=0888a108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0888a108",
  null
  
)

export default component.exports